import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

interface IProps {
    id: string;
    icon: string;
    title: string;
    onClick: any;
}

function Options({ id, icon, title, onClick }: IProps) {
    return (
        <Styles.Wrapper onClick={() => onClick(id)}>
            <Styles.IconFlex>
                <Image
                    width={'24px'}
                    height={'24px'}
                    alt={''}
                    src={getImageBasePath(icon)}
                />
            </Styles.IconFlex>
            <Styles.Title>{title}</Styles.Title>
            <Styles.IconFlex style={{ justifyContent: 'flex-end' }}>
                <Image
                    width={'12px'}
                    height={'12px'}
                    alt={''}
                    src={getImageBasePath('/icons/rightArrow.svg')}
                />
            </Styles.IconFlex>
        </Styles.Wrapper>
    );
}

export default Options;
